import React, { Component } from "react";
import { toast } from "react-toastify";
import Tooltip from 'react-bootstrap/Tooltip';
import { IoInformation } from "react-icons/io5";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import { InputGroup, FormControl, Button, Table, Spinner, Badge } from 'react-bootstrap';
import axios from '../../axios';
import apiError from "../../error";
import HackRecordList from '../../component/hackrecord/hack-component';
import { PiMagnifyingGlassLight } from "react-icons/pi";

import './hackrecord.css'

export default class HackRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            loading: false,
            hackrecord: [],
            isResult: false,
        }
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    records = () => {
        const email = String(this.state.email || '').trim();
        if (!email || !this.validateEmail(email)) {
            toast.error("Please Enter Valid Email Id");
            this.setState({ isResult: false, hackrecord: [] });
            return;
        }
        this.setState({ loading: true, hackrecord: [] });
        axios
            .post('/api/report/hackrecords', { email })
            .then((res) => {
                const results = Array.isArray(res.data?.results) ? res.data.results : [];
                this.setState({
                    isResult: true,
                    loading: false,
                    hackrecord: results,
                });
            })
            .catch((err) => {
                apiError(err);
                this.setState({ loading: false, hackrecord: [], isResult: false });
            });
    };

    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Hack Record

                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='top'>Check if an employee's corporate email ID has ever been compromised</Tooltip>}>
                                        <IoInformation className="tooltip-icon" style={{ 'marginTop': '-1px' }} ></IoInformation>
                                    </OverlayTrigger>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contentbar">


                    <div className="hack-record-hero">
                        <h1 className="hack-record-hero-title">Check  <br></br> Hack Records</h1>
                        <p className="hack-record-hero-desc">Search and identify if any email appears in known breach or hack records</p>
                        <InputGroup className="hack-record-search-wrap">
                            <FormControl type="email" placeholder="Enter email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} onKeyPress={(e) => e.key === 'Enter' && this.records()} />
                            <InputGroup.Append>
                                <Button className="hack-record-search-btn btn-with-icon" onClick={() => this.records()}>
                                    <PiMagnifyingGlassLight /> Search
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                    </div>


                    {this.state.hackrecord.length > 0 && (
                        <div className="hack-record-result">
                            <p className="hack-record-result-count">Data Breach Record <Badge variant="danger" className="badge-soft-danger ml-2">{this.state.hackrecord.length} Data Breach</Badge></p>

                            {this.state.hackrecord.map((record, index) => {
                                const name = record.Name != null ? String(record.Name) : '';
                                const breachDate = record.BreachDate ? new Date(record.BreachDate) : null;
                                const dataClasses = Array.isArray(record.DataClasses) ? record.DataClasses : [];
                                return (
                                    <div key={`hack-record-${index}-${name || 'row'}`} className="hack-record-result-list">
                                        <div className="hack-record-result-header">
                                            <div className="hack-record-result-item-title">
                                                <div className="first-letter">{(name || '?').charAt(0)}</div>
                                                <div className="hack-record-result-item-title-text">{name || '—'}</div>
                                            </div>
                                            <Badge variant="secondary" className="badge-soft-primary ml-2">
                                                {breachDate && !Number.isNaN(breachDate.getTime())
                                                    ? breachDate.toLocaleString('en-US', { month: 'long', year: 'numeric' })
                                                    : '—'}
                                            </Badge>
                                        </div>
                                        <p
                                            className="hack-record-result-item-description"
                                            dangerouslySetInnerHTML={{ __html: record.Description || '' }}
                                        />
                                        <div className="hack-record-result-item-compromised-data-types">
                                            <h6> <span className="dot-icon-circle"></span> Compromised Data Types</h6>
                                            {dataClasses.map((type, i) => (
                                                <Badge key={`${type}-${i}`} variant="secondary" className="badge-soft-secondary ml-2">{type}</Badge>
                                            ))}
                                        </div>

                                    </div>

                                );
                            })}
                        </div>
                    )}

                    {this.state.isResult && !this.state.loading && this.state.hackrecord.length === 0 && (
                        <p className="text-center text-muted mb-0 py-4">No data breach found</p>
                    )}


                    {/* <div className="hackWrapper">
                        <div className="hackBox">
                            <div className="cardHeding">
                                <h6>Hack Records</h6>
                                <p> Enter your email id below and check your hack record status !</p>
                            </div>
                            <InputGroup>
                                <FormControl className="" type="email" onChange={(e) => this.setState({ email: e.target.value })} onKeyPress={e => { if (e.key === 'Enter') { this.records() } }} placeholder="Enter email" value={this.state.email} />
                                <InputGroup.Append>
                                    <Button className="btn_search" disabled={this.state.loading} onClick={() => this.records()}>{this.state.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : <SearchSharpIcon />}</Button>
                                </InputGroup.Append>
                            </InputGroup>
                            {this.state.hackrecord && this.state.hackrecord.length ? null : <h5>{this.state.isResult ? "No hack record found" : ''}</h5>}
                        </div>
                    </div> */}





                    {/* <div className="tableContainerWrapInner">
                        <Table responsive>
                            <thead className="bg-light">
                                <tr>
                                    <th>Domain name
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip id='top'>Domain over which your personal data has been compromised </Tooltip>}>
                                            <IoInformation className="tooltip-icon"></IoInformation>
                                        </OverlayTrigger>
                                    </th>
                                    <th>Breach Date
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip id='top'>Data on which your personal data has been compromised</Tooltip>}>
                                            <IoInformation className="tooltip-icon"></IoInformation>
                                        </OverlayTrigger>

                                    </th>
                                    <th>Description
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip id='top'>A detailed explanation of Breach</Tooltip>}>
                                            <IoInformation className="tooltip-icon"></IoInformation>
                                        </OverlayTrigger>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.hackrecord.map((e, index) => {
                                    return <HackRecordList key={index} hackrecord={e} id={`record${index}`}></HackRecordList>
                                })}
                            </tbody>
                        </Table>
                    </div> */}
                </div>
            </div>
        );
    }
}